import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { last, map, switchMap, tap } from 'rxjs/operators';
import { DeleteAlertComponent } from 'src/app/shared/global_components/delete-alert/delete-alert.component';
import { SnackBarItem } from 'src/app/shared/global_components/snack-bar/snack-bar-item';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LanguageService } from 'src/app/shared/services/common/language.service';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { StorageManagerService } from 'src/app/shared/services/common/storage-manager.service';
import { AuthService } from 'src/app/shared/services/rest/auth.service';
import { CompanyService } from 'src/app/shared/services/rest/company.service';
import { TaskService } from 'src/app/shared/services/rest/task.service';
import { environment } from 'src/environments/environment';
import { CreateWorkStatusComponent } from '../../../../main/dialogs/types/create-work-status/create-work-status.component';
import { EditWorkStatusComponent } from '../../../../main/dialogs/types/edit-work-status/edit-work-status.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-job-types',
  templateUrl: './job-types.component.html',
  styleUrls: ['./job-types.component.scss']
})
export class JobTypesComponent extends BaseClass implements OnInit, OnDestroy {
  public host: any = environment.host;
  public imgRoute: any = '';
  public user: any = {};
  public user_id: number;
  public activeLang: any;
  public company_id: any;
  public selectedTypes: any;
  public company: any;
  public types: any[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private sm: StorageManagerService,
    private auth: AuthService,
    private languageService: LanguageService,
    private taskService: TaskService,
    private dialog: MatDialog,
    private companyService: CompanyService,
    private bottomSheet: MatBottomSheet,
    private layoutService: LayoutService,
    private router: Router,
  ) { 
    super()
  }

  ngOnInit(): void {
    this.company_id = this.activatedRoute.snapshot.queryParamMap.get('company_id');

    this.getLangData();
    this.getImgRoute();
    this.getCsrf();
    this.getUser();
    this.getTypes();
    this.getSelectedOperations();
    this.getCompany();
  }

  // 
  editType(type) {
    const dialogRef = this.dialog.open(EditWorkStatusComponent, {
      data: {
        company: this.company,
        types: this.types,
        type: type,
        activeLang: this.activeLang
      }
    });

    this.attachSubscriptions(
      dialogRef.afterClosed().subscribe(result => {
        this.getTypes();
      })
    )
  }

  createType() {
    this.dialog.open(CreateWorkStatusComponent, {
      data: {
        company: this.company,
        types: this.types
      }
    });
  }

  deleteType(type, i) {
    let deleteAlert =  this.bottomSheet.open(DeleteAlertComponent, {
      hasBackdrop: true,
      backdropClass: 'bottom-sheed-backdrop',
      data: {
        targetVal: {},
        target: marker("job type")
      }
    });

    deleteAlert.afterDismissed().subscribe( data => {
      if (data && data.message == 'no') {
        console.log("no");
        return
      } else if (data && data.message == 'yes') {
        this.attachSubscriptions(
          this.taskService.deleteOperation(type.id).subscribe(resp => {
            this.types.splice(i,1);
          })
        )
      }
    });
   
  }

  getSelectedOperations() {
    this.attachSubscriptions(
      this.taskService.getSelectedOperations(this.company_id).subscribe(resp => {
        console.log("selectedTypes", resp)
        this.selectedTypes = resp
      })
    )
  }

  toggleType(e, type) {
    type.disabled = true
    console.log(this.types)
    if (e.checked) {
      this.selectType(type, e);
    } else {
      this.unSelectType(type, e);
    }
  }

  selectType(type, e) {
    this.attachSubscriptions(
      this.taskService.selectOperation({
        operation_id: type.id,
        company_id: this.company_id
      }).pipe(
        switchMap(x => {
          return this.taskService.getSelectedOperations(this.company_id, type.id).pipe(
            tap(z => {
              type.operationToCompany = [...z]
            })
          )
        })
      ).subscribe(
        resp => {
          console.log(resp);
          type.disabled = false;
        },
        error => {
          type.disabled = false;
          e.source.toggle();
          this.layoutService.showSnackBar({}, error, SnackBarItem)
        } 
      )
    )
  }

  unSelectType(type, e) {

    this.attachSubscriptions(
      this.taskService.unSelectOperation(type.operationToCompany[0].id).subscribe(
        resp => {
          console.log(resp);
          type.operationToCompany = [];
          type.disabled = false;
        },
        error => {
          type.disabled = false;
          e.source.toggle();
          this.layoutService.showSnackBar({}, error, SnackBarItem)
        } 
      )
    )
  }

  goBack() {
    history.back();
  }

  // getTypes() {
  //   this.attachSubscriptions(
  //     this.taskService.getOperationsToCompany(this.company_id, this.activeLang).subscribe(resp => {
  //       console.log(resp)
  //       this.types = resp
  //     })
  //   )
  // }

  getTypes() {
    this.attachSubscriptions(
      this.taskService.getOperationsToCompanyDyn('1', this.company_id, this.activeLang).pipe(
        switchMap(el => {
          let pages = Math.ceil(el.headers.get('x-pagination-total-count') / 200)
          let arr = []
          for (let index = 1; index <= pages; index++) {
            arr.push(index)
          }

          return forkJoin(arr.map(x => this.taskService.getOperationsToCompanyDyn(x, this.company_id, this.activeLang).pipe(map(u => u.body)))).pipe(
            last(),
          )
        }),
      ).subscribe(res => {
        this.types = [].concat(...res).sort((a, b) => a.name.localeCompare(b.name));
      })
    )
  }
  
  getLangData() {
    this.attachSubscriptions(
      this.languageService.getLangData().subscribe(resp => {
        this.activeLang = resp.active;
      })
    )
  }

  getImgRoute() {
    this.attachSubscriptions(
      this.sm.getImgPath().subscribe(el => {
        this.imgRoute = el;
      })
    )
  }

  getCompany() {
    this.attachSubscriptions(
      this.companyService.getCompany(this.company_id).subscribe(resp => {
        this.companyService.company$.next(resp[0]);
        this.company = resp[0];
      })
    )
  }

  getCsrf() {
    this.attachSubscriptions(
      this.auth.$userToken.subscribe(resp => {
        this.user_id = resp.user_id;
        this.sm.localStorageSetItem("csrf_param", resp.csrf_param)
        this.sm.localStorageSetItem("csrf_token", resp.csrf_token)
      })
    )
  }

  getUser() {
    this.attachSubscriptions(
      this.auth.$user.subscribe(resp => {
        console.log("USER", resp)
        this.user = resp;
      })
    )
  }

  ngOnDestroy(): void {
    this.clearSubscriptions()
  }

}
